import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../_redux/personnel-report/PersonnelReportAction";
import * as uiHelpers from "../PersonnelReportUIHelpers";
import {
  getHandlerTableChange,  
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { usePersonnelReportUIContext } from "../PersonnelReportUIContext";
import { FilterButtonsTable } from "./FilterButtonsTable";

export function PersonnelReportTable({
  columns,
  setColumns
}) {
  // Personnel Report UI Context
  const personnelReportUIContext = usePersonnelReportUIContext();
  const personnelReportUIProps = useMemo(() => {
    return {
      queryParams: personnelReportUIContext.queryParams,
      setQueryParams: personnelReportUIContext.setQueryParams
    };
  }, [personnelReportUIContext]);

  // Getting curret state of Personnel Report from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.personnelReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Personnel Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getPersonnelReport(personnelReportUIProps.queryParams));
    return () => dispatch(actions.cleanPersonnelReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personnelReportUIProps.queryParams, dispatch]);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: personnelReportUIProps.queryParams.pageSize,
    page: personnelReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <FilterButtonsTable
              columns={columns}
              setColumns={setColumns}
            />
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                personnelReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>
  );
}